import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { event } from 'jquery';
import { forEach } from 'lodash';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { MessageService } from 'primeng/api';
import { Subject, debounceTime } from 'rxjs';
import { AccountManagementService } from 'src/app/services/account-management.service';
import { ExportExcelService } from 'src/app/services/export-excel.service';
import { StorageService } from 'src/app/services/storage.service';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';
import { UserProfileService } from 'src/app/services/user-profile.service';
import { TableColumn } from 'src/app/shared-components/data-table/data-table.component';

@Component({
  selector: 'app-reports-landing',
  templateUrl: './reports-landing.component.html',
  styleUrls: ['./reports-landing.component.scss'],
  standalone: false,
})
export class ReportsLandingComponent implements OnInit {
  readonly stampDashboardColumns: TableColumn[] = [
    { field: 'state', header: 'State Name' },
    { field: 'stamp_type', header: 'Stamp Type' },
    { field: 'denomination', header: 'Denomination' },
    { field: 'order_given_count', header: 'Total Stamps Requested' },
    { field: 'procured', header: 'Total Stamps Procured' },
    { field: 'to_be_procure', header: 'Stamps to be Procured' },
    { field: 'amount', header: 'Total Amount' },
    { field: 'consumed', header: 'Consumed Stamps' },
    { field: 'available', header: 'Availible Stamps' },
    { field: 'article', header: 'Article', fallback: 'NA' },
  ];

  @ViewChild('calendar') calendar: any;
  selectedState: any;
  selectedAccountId: number = null;
  selectedStateId: number = null;
  selectState: any;
  rangeDates: Date;
  selectedDate: any;
  summaryReportData: any = [];
  displayBranch!: any;
  reportFilters: any = {};
  fieldsToDisplay: any = [
    'user_name',
    'order_status',
    'user_email',
    'branch',
    'state',
    'order_type',
    'account',
    'total_stamps',
    'first_party_name',
    'second_party_name',
    'stamp_duty_paid_by',
    'stamp_duty_amount',
    'total_stamps_amount',
    'execution_date',
    'certificate_number',
    'referance_number',
    'issued_date',
    'denomination',
    'cess_amount',
    'email',
    'sign_method',
    'status',
    'sign_url',
    'signed_at',
    'first_party_pan',
    'second_party_pan',
  ];
  dailyReportFilters = {
    estamp_fields: [],
    start_date: moment(new Date()).format('YYYY-MM-DD'),
    end_date: moment(new Date()).format('YYYY-MM-DD'),
  };
  OrderData: any;
  eStampData: any;
  eSignData: any;
  startDate: string;
  endDate: string;

  accounts: any;
  states: any;
  branches: any = [];
  users: any;

  tabIndex: number = 0;

  readonly reportsTabs = [
    { label: 'Summary', icon: 'pi pi-chart-bar' },
    { label: 'Stamp Dashboard', icon: 'pi pi-table' },
    { label: 'Consumption Reports', icon: 'pi pi-file' },
  ];

  selectedBranch: any = '';
  checkboxOptions = [
    { fieldName: 'User Name', value: 'user_name', checked: true },
    { fieldName: 'Order Status', value: 'order_status', checked: true },
    { fieldName: 'User Email', value: 'user_email', checked: true },
    { fieldName: 'Branch', value: 'branch', checked: true },
    { fieldName: 'State', value: 'state', checked: true },
    { fieldName: 'Order Type', value: 'order_type', checked: true },
    { fieldName: 'Account', value: 'account', checked: true },
    { fieldName: 'Total Stamps', value: 'total_stamps', checked: true },
    { fieldName: 'First Party Name', value: 'first_party_name', checked: true },
    {
      fieldName: 'Second Party Name',
      value: 'second_party_name',
      checked: true,
    },
    {
      fieldName: 'Stamp Duty Paid By',
      value: 'stamp_duty_paid_by',
      checked: true,
    },
    {
      fieldName: 'Stamp Duty Amount',
      value: 'stamp_duty_amount',
      checked: true,
    },
    {
      fieldName: 'Total Stamps Amount',
      value: 'total_stamps_amount',
      checked: true,
    },
    { fieldName: 'Execution Date', value: 'execution_date', checked: true },
    {
      fieldName: 'Certificate Number',
      value: 'certificate_number',
      checked: true,
    },
    { fieldName: 'Reference Number', value: 'referance_number', checked: true },
    { fieldName: 'Issued Date', value: 'issued_date', checked: true },
    { fieldName: 'Denomination', value: 'denomination', checked: true },
    { fieldName: 'Cess Amount', value: 'cess_amount', checked: true },
    { fieldName: 'Email', value: 'email', checked: true },
    { fieldName: 'Sign Method', value: 'sign_method', checked: true },
    { fieldName: 'Status', value: 'status', checked: true },
    { fieldName: 'Sign URL', value: 'sign_url', checked: true },
    { fieldName: 'Signed At', value: 'signed_at', checked: true },
    { fieldName: 'Organization', value: 'organisation', checked: true },
    { fieldName: 'First Party Pan', value: 'first_party_pan', checked: true },
    { fieldName: 'Second Party Pan', value: 'second_party_pan', checked: true },
  ];
  selectedFields: string[] = [];
  maxDate = new Date();
  maxDateForConsumption: Date;
  stampDashboardData: any = [];
  pageNo: number = 1;
  totalRecords: number = 10;

  stampDashboardFilters: any = {
    account_id: this.storageService.getAccountId() || null,
    state_code: '',
  };

  onSearchTextChange: Subject<string> = new Subject<string>();
  accountFilter = {
    search: '',
  };
  //rangeDates3: Date[] = [new Date(), new Date()];
  rangeDates3: Date;
  dailyReportDaterange: Date;
  @ViewChild('calendarConsumpReport') calendarConsumpReport: any;
  @ViewChild('calendarDailyReport') calendarDailyReport: any;
  consumptionReportFilters: any = {
    sync: 'true',
    start_date: '',
    end_date: '',
  };
  selectedAccountForSummary: any = '';
  selectedAccountForStampDashboard: any = '';
  selectedAccountForConsmpReport: any = '';
  checkboxOptionsForConsumpReport = [
    { fieldName: 'Order Date', value: 'order_date', checked: false },
    { fieldName: 'Order ID', value: 'order_id', checked: false },
    { fieldName: 'Reference ID', value: 'referance_id', checked: false },
    { fieldName: 'Order Status', value: 'order_status', checked: false },
    { fieldName: 'Order Type', value: 'order_type', checked: false },
    {
      fieldName: 'Consumption Date',
      value: 'consumption_date',
      checked: false,
    },
    { fieldName: 'User Name', value: 'user_name', checked: false },
    { fieldName: 'User Email', value: 'user_email', checked: false },
    { fieldName: 'Account', value: 'account', checked: false },
    { fieldName: 'Branch', value: 'branch', checked: false },
    { fieldName: 'State Code', value: 'st_code', checked: false },
    {
      fieldName: 'First Party Name',
      value: 'first_party_name',
      checked: false,
    },
    {
      fieldName: 'Second Party Name',
      value: 'second_party_name',
      checked: false,
    },
    { fieldName: 'First Party PAN', value: 'first_party_pan', checked: false },
    {
      fieldName: 'Second Party PAN',
      value: 'second_party_pan',
      checked: false,
    },
    {
      fieldName: 'Stamp Duty Paid By',
      value: 'stamp_duty_paid_by',
      checked: false,
    },
    { fieldName: 'Description', value: 'description', checked: false },
    { fieldName: 'Article Code', value: 'article_code', checked: false },
    {
      fieldName: 'Consideration Amount',
      value: 'consideration_amount',
      checked: false,
    },
    {
      fieldName: 'Stamp Duty Amount',
      value: 'stamp_duty_amount',
      checked: false,
    },
    { fieldName: 'Execution Date', value: 'execution_date', checked: false },
    { fieldName: 'State', value: 'state', checked: false },
    { fieldName: 'Total Stamps', value: 'total_stamps', checked: false },
    {
      fieldName: 'Total Stamps Amount',
      value: 'total_stamps_amount',
      checked: false,
    },
    {
      fieldName: 'Certificate Number',
      value: 'certificate_number',
      checked: false,
    },
    {
      fieldName: 'Reference Number',
      value: 'referance_number',
      checked: false,
    },
    { fieldName: 'Stamp Type', value: 'stamp_type', checked: false },
    { fieldName: 'Issued Date', value: 'issued_date', checked: false },
    { fieldName: 'Denomination', value: 'denomination', checked: false },
    {
      fieldName: 'Total Denomination Amount',
      value: 'total_denomination_amount',
      checked: false,
    },
    { fieldName: 'Total Sign', value: 'total_sign', checked: false },
    {
      fieldName: 'Total Sign Completed',
      value: 'total_sign_completed',
      checked: false,
    },
    {
      fieldName: 'Electronic Sign Requested',
      value: 'electronic_sign_requested',
      checked: false,
    },
    {
      fieldName: 'Aadhaar Sign Requested',
      value: 'aadhaar_sign_requested',
      checked: false,
    },
    {
      fieldName: 'DSC Sign Requested',
      value: 'dsc_sign_requested',
      checked: false,
    },
    {
      fieldName: 'Electronic Sign Completed',
      value: 'electronic_sign_completed',
      checked: false,
    },
    {
      fieldName: 'Aadhaar Sign Completed',
      value: 'aadhaar_sign_completed',
      checked: false,
    },
    {
      fieldName: 'DSC Sign Completed',
      value: 'dsc_sign_completed',
      checked: false,
    },
    { fieldName: 'Payment Status', value: 'payement_status', checked: false },
    { fieldName: 'Payment Amount', value: 'payment_amount', checked: false },
    { fieldName: 'POD Details', value: 'POD_details', checked: false },
    { fieldName: 'Dispatch Date', value: 'dispatch_date', checked: false },
    { fieldName: 'Courier Name', value: 'courier_name', checked: false },
    {
      fieldName: 'Pre Procurement ID',
      value: 'pre_procurement_id',
      checked: false,
    },
  ];
  checkboxOptionsForConsumpReportGrouped: any[][] = [];
  selectedFieldsForConsumpReport: string[] = [];
  isShowDailyReports: boolean = false;

  selectedAccountForDailyReport: any;
  selectedBranchForDailyReport: any;
  dateRanges = [
    { name: 'Last Month', code: 'lastOneMonth' },
    { name: 'Last 3 Months', code: 'lastThreeMonths' },
    { name: 'Last 6 Months', code: 'lastSixMonths' },
    { name: 'Last 1 Year', code: 'lastOneYear' },
  ];
  selectedPeriod: any;
  userRole: string;

  constructor(
    private storageService: StorageService,
    private router: Router,
    private accountManagementService: AccountManagementService,
    private exportExcelService: ExportExcelService,
    private userDashboardService: UserDashboardService,
    private messageService: MessageService,
    private cookieService: CookieService,
    private cdr: ChangeDetectorRef,
    private userProfileService: UserProfileService,
  ) {
    this.summaryReportData = [
      {
        name: 'Total Orders',
        count: 0,
        percentage: +2.4,
        icon: 'icon_color bx bxl-dropbox bx-md',
      },
      {
        name: 'In Progress',
        count: 0,
        percentage: +2.4,
        icon: 'icon_color bx bxs-time-five bx-md',
      },
      {
        name: 'Completed Order',
        count: 0,
        percentage: +2.4,
        icon: 'icon_color bx bxs-package bx-md',
      },
      {
        name: 'Total Stamp Amount',
        count: 0,
        percentage: +2.4,
        icon: 'icon_color bx bxs-box bx-md',
      },
      {
        name: 'Cancelled Orders',
        count: 0,
        percentage: +2.4,
        icon: 'icon_color bx bxs-x-square bx-md',
      },
      {
        name: 'Total Signatures Requested',
        count: 0,
        percentage: +2.4,
        icon: 'icon_color bx bxs-time-five bx-md',
      },
      {
        name: 'Total Signatures Completed',
        count: 0,
        percentage: +2.4,
        icon: 'icon_color bx bxs-package bx-md',
      },
      {
        name: 'Waiting for Stamps',
        count: 0,
        percentage: +2.4,
        icon: 'icon_color bx bx-stopwatch bx-md',
      },
      {
        name: 'Expired',
        count: 0,
        percentage: +2.4,
        icon: 'icon_color bx bx-calendar-x bx-md',
      },
    ];

    this.onSearchTextChange.pipe(debounceTime(1500)).subscribe((value) => {
      this.accountFilter.search = value;
      this.accountFilter = Object.assign({}, this.accountFilter);
      value === ''
        ? this.getAccountDetails()
        : this.getFilteredAccountDqetail(this.accountFilter);
    });

    this.userRole = this.storageService.getRole() || null;
  }

  ngOnInit(): void {
    this.getAccountDetails();
    // this.getStateDetails();
    // this.getBranchDetails();
    //this.getUsersDetails();

    //this.groupCheckboxOptions();
    this.checkboxOptions.forEach((option) => {
      this.selectedFields.push(option.value);
    });
    this.checkboxOptionsForConsumpReport.forEach((option) => {
      this.selectedFieldsForConsumpReport.push(option.value);
    });

    this.maxDateForConsumption = new Date();
    this.maxDateForConsumption.setDate(
      this.maxDateForConsumption.getDate() - 1,
    );
  }

  getAccountDetails() {
    this.userDashboardService.getAccountDetail().subscribe((res: any) => {
      this.accounts = res.content;
      // this.getDefaultAccountDetails();
    });
  }

  getDefaultAccountDetails() {
    const account_id = this.storageService.getAccountId();
    if (account_id) {
      this.accountManagementService
        .getAccountDetail(account_id)
        .subscribe((res) => {
          //  this.accounts.push(res['content'][0]);
          this.selectedAccountForStampDashboard = res['content'][0].id;
          this.stampDashboardFilters['account_id'] = [];
          this.stampDashboardFilters.account_id.push(
            this.selectedAccountForStampDashboard,
          );
          this.getStampDashboardData();
        });
    }
  }

  getFilteredAccountDqetail(accountFilter) {
    this.userDashboardService
      .getFilteredAccountDqetail(accountFilter)
      .subscribe((res: any) => {
        this.accounts = res.content;
        this.cdr.detectChanges();
      });
  }

  onAccountFilter(evt) {
    if (evt.filter === null) {
      this.accountFilter.search = '';
      this.onSearchTextChange.next('');
    } else this.onSearchTextChange.next(evt.filter);
  }

  onChangeTab(evt: any) {
    this.tabIndex = evt.index;
    this.selectedAccountForDailyReport = '';
    this.selectState = '';
    this.selectedBranchForDailyReport = '';
    this.isShowDailyReports = false;
    this.branches = [];
    this.getAccountDetails();
    this.startDate = '';
    this.endDate = '';
    if (evt.index === 0) this.selectedAccountForSummary = '';
    delete this.dailyReportFilters.estamp_fields;
    if (evt.index === 1) this.selectedAccountForStampDashboard = '';

    if (evt.index === 2) {
      this.selectedPeriod = '';
      this.selectedAccountForConsmpReport = '';
      this.rangeDates3 = null;
      this.loadConsumptionReportColumns();
    }
  }

  loadConsumptionReportColumns() {
    const accountId = this.storageService.getAccountId();
    if (!accountId) return;
    this.userProfileService
      .getOrderReviewConsent(accountId)
      .subscribe((res: any) => {
        const savedColumns: string[] =
          res?.content?.consumption_report_columns || [];
        this.checkboxOptionsForConsumpReport.forEach((opt) => {
          opt.checked = savedColumns.includes(opt.value);
        });
        this.cdr.detectChanges();
      });
  }

  saveConsumptionReportColumns() {
    const accountId = this.storageService.getAccountId();
    const selectedColumns = this.checkboxOptionsForConsumpReport
      .filter((opt) => opt.checked)
      .map((opt) => opt.value);
    const payload = {
      account_id: accountId,
      consumption_report_columns: selectedColumns,
    };
    this.userProfileService.orderReviewConsent(payload).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Consumption report columns saved successfully',
          icon: 'pi-check-circle',
        });
        this.loadConsumptionReportColumns();
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Failed to save columns',
        });
      },
    });
  }

  getStateDetails(account_id: number) {
    this.userDashboardService
      .getStatesByAccount(account_id)
      .subscribe((res: any) => {
        this.states = res['content'];
        this.cdr.detectChanges();
      });
  }

  getBranchDetails() {
    this.userDashboardService.getBranchList().subscribe((res: any) => {
      this.branches = res['content'];

      if (this.selectState != null) {
        this.branches = this.branches.filter(
          (element) => element.state.id === this.selectState,
        );
      }
      this.cdr.detectChanges();
    });
  }

  getBranchDetailsByAccountAndState(account_id, state_id) {
    this.userDashboardService
      .getBranchListByAccountAndState(account_id, state_id)
      .subscribe((res: any) => {
        this.branches = res['content'];

        if (this.selectState != null) {
          this.branches = this.branches.filter(
            (element) => element.state.id === this.selectState,
          );
        }
        this.cdr.detectChanges();
      });
  }

  getUsersDetails() {
    this.userDashboardService.getUsersDetails().subscribe((res: any) => {
      this.users = res['content'];
      this.cdr.detectChanges();
    });
  }

  getOrdersCount() {
    this.userDashboardService.getOrdersCount().subscribe((res: any) => {
      this.OrderData = res['content'];

      this.summaryReportData[0].count = this.OrderData.total_orders;
      this.summaryReportData[1].count = this.OrderData.in_progress;
      this.summaryReportData[2].count = this.OrderData.completed_orders;
      this.summaryReportData[3].count = this.OrderData.total_stamp_amount;
      this.summaryReportData[4].count = this.OrderData.cancelled_orders;
      this.summaryReportData[5].count = this.OrderData.total_signature;
      this.summaryReportData[6].count =
        this.OrderData.total_signature_completed;
      this.summaryReportData[7].count = this.OrderData.waiting_for_stamps;
      this.summaryReportData[8].count = this.OrderData.expired_orders;
      this.cdr.detectChanges();
    });
  }

  getDashBoard() {
    this.userDashboardService.getDashboard().subscribe((res: any) => {
      this.OrderData = res['content'].order;
      this.eStampData = res['content'].estamp;
      this.eSignData = res['content'].esign;
      this.summaryReportData[0].count = this.OrderData.total_order.count;
      this.summaryReportData[1].count = this.OrderData.in_progress_order.count;
      this.summaryReportData[2].count = this.OrderData.complete_order.count;
      this.summaryReportData[4].count = this.OrderData.cancelled_orders;
      this.summaryReportData[5].count = this.eSignData.total_order;
      this.summaryReportData[6].count = this.eSignData.completed_orders;
      this.summaryReportData[7].count = this.OrderData.waiting_for_stamps;
      this.summaryReportData[8].count = this.OrderData.expired_orders;
      this.cdr.detectChanges();
    });
  }
  getSelected() {
    this.cookieService.set('BranchName', this.selectedState);
    this.storageService.setBranch(this.selectedState);
  }
  gotoDashboard() {
    this.userRole === 'CLIENT'
      ? this.router.navigate(['doqfy/dashboard'])
      : this.router.navigate(['doqfy/admin-dashboard']);
  }

  onSelect() {
    if (this.rangeDates[1]) {
      this.startDate = moment(this.rangeDates[0]).format('YYYY-MM-DD');
      this.endDate = moment(this.rangeDates[1]).format('YYYY-MM-DD');
      this.calendar.overlayVisible = false;
      this.reportFilters['start_date'] = this.startDate;
      this.reportFilters['end_date'] = this.endDate;
      // this.userDashboardService.getOrdersCount(this.startDate, this.endDate).subscribe((res: any) => {

      //   this.OrderData = res['content'];
      //   this.summaryReportData[0].count = this.OrderData.total_orders;
      //   this.summaryReportData[1].count = this.OrderData.in_progress;
      //   this.summaryReportData[2].count = this.OrderData.completed_orders;
      //   this.summaryReportData[3].count = this.OrderData.total_stamp_amount;
      //   this.summaryReportData[4].count = this.OrderData.total_stamp;
      //   this.summaryReportData[5].count = this.OrderData.total_signature;
      //   this.summaryReportData[6].count = this.OrderData.total_signature_completed;
      // })
    }
  }

  filterState(filterData) {
    // const param = '?start_date=' + filterData.start_date + '&end_date=' + filterData.end_date + '&account_ids=' + filterData.account_ids + '&branch_ids=' + filterData.branch_ids
    //   + '&state_ids=' + filterData.state_ids;
    this.userDashboardService
      .getFilterDetailsForReportsSummary(filterData)
      .subscribe((res) => {
        this.OrderData = res['content'];
        this.summaryReportData[0].count = this.OrderData.total_orders;
        this.summaryReportData[1].count = this.OrderData.in_progress;
        this.summaryReportData[2].count = this.OrderData.completed_orders;
        this.summaryReportData[3].count = this.OrderData.total_stamp_amount;
        this.summaryReportData[4].count = this.OrderData.cancelled_orders;
        this.summaryReportData[5].count = this.OrderData.total_signature;
        this.summaryReportData[6].count =
          this.OrderData.total_signature_completed;
        this.summaryReportData[7].count = this.OrderData.waiting_for_stamps;
        this.summaryReportData[8].count = this.OrderData.expired_orders;
        this.cdr.detectChanges();
      });
  }

  formatDateWithTime(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }

  export() {
    this.dailyReportFilters['estamp_fields'] = this.selectedFields;
    const today = new Date();
    const formattedDate = this.formatDateWithTime(today);

    let fileName = 'Consumptio Report' + '_' + formattedDate;
    this.exportExcelService
      .getOrderConsumption(this.dailyReportFilters)
      .subscribe((res) => {
        if (res.status === 200 && res['message'] != 'No records found') {
          //this.exportExcelService.base64ToCSV(res['content'], fileName);
          this.messageService.add({
            severity: 'success',
            summary: res.message,
            icon: 'pi-check-circle',
          });
          this.resetCheckboxes();
          this.selectedAccountForDailyReport = '';
          this.selectState = '';
          this.selectedBranchForDailyReport = '';
          this.branches = [];
          this.dailyReportDaterange = null;
          this.dailyReportFilters.start_date = moment(new Date()).format(
            'YYYY-MM-DD',
          );
          this.dailyReportFilters.end_date = moment(new Date()).format(
            'YYYY-MM-DD',
          );
          this.dailyReportFilters = Object.assign({}, this.dailyReportFilters);
        } else {
          this.messageService.add({ severity: 'warn', summary: res.message });
          this.resetCheckboxes();
        }
      });
  }

  onChangeAccount(event) {
    if (event.value === null) {
      delete this.reportFilters['account_ids'];
      this.selectedAccountForConsmpReport = '';
    } else {
      this.reportFilters['account_ids'] = [];
      const selectedAccount = this.accounts.find(
        (acc) => acc.id === event.value,
      );
      this.selectedAccountId = selectedAccount.account_id;
      this.selectedAccountForConsmpReport = selectedAccount.account_id;
      this.reportFilters.account_ids.push(selectedAccount.account_id);
      this.getStateDetails(this.selectedAccountId);
    }
  }

  onChangeAccountForDailyReport(event) {
    if (event.value === null) {
      delete this.dailyReportFilters['account_id'];
      this.selectedAccountForConsmpReport = '';
      this.selectedAccountId = null;
      this.states = [];
      this.branches = [];
    } else {
      this.dailyReportFilters['account_id'] = [];
      const selectedAccount = this.accounts.find(
        (acc) => acc.id === event.value,
      );
      this.dailyReportFilters['account_id'].push(selectedAccount.account_id);
      this.selectedAccountForConsmpReport = event.value;
      this.selectedAccountId = selectedAccount.account_id;
      this.getStateDetails(this.selectedAccountId);
    }
  }

  onChangeState(event) {
    if (event.value === null) delete this.reportFilters['state_ids'];
    else {
      this.reportFilters['state_ids'] = [];
      this.reportFilters.state_ids.push(event.value);
      this.selectedStateId = event.value;
      this.getBranchDetailsByAccountAndState(
        this.selectedAccountId,
        this.selectedStateId,
      );
      // this.getBranchDetails()
    }
  }

  onChangeStateForDailyReport(event) {
    if (event.value === null) delete this.dailyReportFilters['state_id'];
    else {
      this.dailyReportFilters['state_id'] = [];
      this.dailyReportFilters['state_id'].push(event.value);
      // this.getBranchDetails();
      this.selectedStateId = event.value;
      this.getBranchDetailsByAccountAndState(
        this.selectedAccountId,
        this.selectedStateId,
      );
    }
  }

  onChangeBranch(event) {
    if (event.value === null) delete this.reportFilters['branch_ids'];
    else {
      this.reportFilters['branch_ids'] = [];
      this.reportFilters.branch_ids.push(event.value);
    }
  }

  onChangeBranchForDailyReport(event) {
    if (event.value === null) delete this.dailyReportFilters['branch_id'];
    else {
      this.dailyReportFilters['branch_id'] = [];
      this.dailyReportFilters['branch_id'].push(event.value);
    }
  }

  onChangeUser(event) {
    this.reportFilters['user_ids'] = [];
    this.reportFilters.user_ids.push(event.value);
  }

  onCheckboxChange(option: any) {
    if (option.checked) {
      this.selectedFields.push(option.value);
    } else {
      const index = this.selectedFields.indexOf(option.value);
      if (index !== -1) {
        this.selectedFields.splice(index, 1);
      }
    }
  }

  resetCheckboxes() {
    this.selectedFields = [];
    this.checkboxOptions.forEach((option) => {
      option.checked = true;
    });
    this.checkboxOptions.forEach((option) => {
      this.selectedFields.push(option.value);
    });
  }

  onDateRangeChange(evt) {
    if (evt === null) {
      delete this.reportFilters['start_date'];
      delete this.reportFilters['end_date'];
      this.reportFilters = Object.assign({}, this.reportFilters);
    }
  }

  onDateRangeChangeForConsumpReport(evt) {
    if (evt === null) {
      delete this.consumptionReportFilters['start_date'];
      delete this.consumptionReportFilters['end_date'];
      this.consumptionReportFilters = Object.assign(
        {},
        this.consumptionReportFilters,
      );
      this.rangeDates3 = null;
    }
  }

  onDateRangeChangeForDailyReport(evt) {
    if (evt === null) {
      this.dailyReportFilters.start_date = moment(new Date()).format(
        'YYYY-MM-DD',
      );
      this.dailyReportFilters.end_date = moment(new Date()).format(
        'YYYY-MM-DD',
      );
      this.dailyReportFilters = Object.assign({}, this.dailyReportFilters);
      this.dailyReportDaterange = null;
    }
  }

  getStampDashboardData() {
    this.stampDashboardFilters.account_id === undefined
      ? (this.stampDashboardFilters.account_id = '')
      : this.stampDashboardFilters.account_id;
    this.stampDashboardFilters.state_code === undefined
      ? (this.stampDashboardFilters.state_code = '')
      : this.stampDashboardFilters.state_code;
    this.userDashboardService
      .getStampDashboardData(this.stampDashboardFilters)
      .subscribe((res) => {
        this.stampDashboardData = res['content'];
        this.cdr.detectChanges();
      });
  }

  onPageChange(event: any) {
    if (event) {
      // this.orderFilters["page_number"] = event.page + 1
      // this.orderFilters["page_size"] = event.rows
      // this.getStampDetails(this.orderFilters)
    }
  }

  onAccountChange(event) {
    if (event.value === null) {
      delete this.reportFilters['account_ids'];
      this.selectedAccountForConsmpReport = '';
    } else {
      this.reportFilters['account_ids'] = [];
      const selectedAccount = this.accounts.find(
        (acc) => acc.id === event.value,
      );
      this.selectedAccountForConsmpReport = selectedAccount.account_id;
      this.getStateDetails(selectedAccount.account_id);
    }
    this.getStampDashboardData();
  }

  onStateChange(event) {
    if (event.value === null) delete this.stampDashboardFilters['state_code'];
    else {
      let selectedStateCode;
      this.states.forEach((option) => {
        if (event.value === option.id) selectedStateCode = option.state_code;
      });
      this.stampDashboardFilters['state_code'] = [];
      this.stampDashboardFilters.state_code.push(selectedStateCode);
    }
    this.getStampDashboardData();
  }

  exportStampDashboardData() {
    const today = new Date();
    const formattedDate = this.formatDateWithTime(today);

    let fileName = 'Stamp_Dashboard_Report' + '_' + formattedDate;
    this.userDashboardService
      .exportStampDashboardData(this.stampDashboardFilters)
      .subscribe((res) => {
        if (res.status === 200 && res['message'] != 'No records found') {
          this.exportExcelService.base64ToCSV(res['content'], fileName);
          this.messageService.add({
            severity: 'success',
            summary: 'Reports Downloaded Successfully',
            icon: 'pi-check-circle',
          });
        } else {
          this.messageService.add({ severity: 'warn', summary: res.message });
        }
      });
  }

  onSelectConsumpReportDate() {
    this.consumptionReportFilters['start_date'] = '';
    this.consumptionReportFilters['end_date'] = '';
    this.selectedPeriod = '';
    if (this.rangeDates3[1]) {
      this.calendarConsumpReport.overlayVisible = false;
      this.startDate = moment(this.rangeDates3[0]).format('YYYY-MM-DD');
      this.endDate = moment(this.rangeDates3[1]).format('YYYY-MM-DD');
      this.consumptionReportFilters['start_date'] = this.startDate;
      this.consumptionReportFilters['end_date'] = this.endDate;
    }
  }

  onSelectConsumpReportDateValue(evt) {
    this.rangeDates3 = null;

    this.selectedPeriod = evt.value;
    const selectedEndDate = moment(new Date());

    let daysToSubtract = 0;
    let year = null;

    switch (evt.value) {
      case 'lastOneMonth':
        daysToSubtract = 30;
        break;
      case 'lastThreeMonths':
        daysToSubtract = 90;
        break;
      case 'lastSixMonths':
        daysToSubtract = 180;
        break;
      case 'lastOneYear':
        daysToSubtract = 365;
        break;
      default:
        break;
    }

    let startDate = '';
    let endDate = '';
    endDate = selectedEndDate.endOf('day').format('YYYY-MM-DD');
    startDate = selectedEndDate
      .clone()
      .subtract(daysToSubtract, 'days')
      .startOf('day')
      .format('YYYY-MM-DD');

    this.startDate = startDate;
    this.endDate = endDate;
    this.consumptionReportFilters['start_date'] = startDate;
    this.consumptionReportFilters['end_date'] = endDate;
  }

  onSelectDailyReportDate() {
    if (this.dailyReportDaterange[1]) {
      this.calendarDailyReport.overlayVisible = false;
      this.startDate = moment(this.dailyReportDaterange[0]).format(
        'YYYY-MM-DD',
      );
      this.endDate = moment(this.dailyReportDaterange[1]).format('YYYY-MM-DD');
      this.dailyReportFilters['start_date'] = this.startDate;
      this.dailyReportFilters['end_date'] = this.endDate;
    }
  }

  getConsumptionReport() {
    if (
      this.selectedAccountForConsmpReport === '' &&
      (this.consumptionReportFilters.start_date === '' ||
        this.consumptionReportFilters.end_date === '')
    ) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Please select account and date range',
      });
      return;
    } else if (this.selectedAccountForConsmpReport === '') {
      this.messageService.add({
        severity: 'warn',
        summary: 'Please select account',
      });
      return;
    }
    // else if (Array.isArray(this.rangeDates3) && this.rangeDates3.length === 2 && this.rangeDates3[1] === null) {
    //   this.messageService.add({
    //     severity: 'warn', summary: 'Please select a complete date range to generate the report'
    //   });
    else if (
      this.consumptionReportFilters.start_date === '' ||
      this.consumptionReportFilters.end_date === ''
    ) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Please select a date range or period to generate the report',
      });
      return;
    } else {
      let payload = {
        sync: 'false',
        start_date: this.consumptionReportFilters.start_date,
        end_date: this.consumptionReportFilters.end_date,
        account_ids: [this.selectedAccountForConsmpReport],
      };
      const today = new Date();
      const formattedDate = this.formatDateWithTime(today);

      let fileName = 'Consumptio Report' + '_' + formattedDate;
      this.userDashboardService
        .getConsumptionReport(payload)
        .subscribe((res: any) => {
          if (res.status === 200 && res['message'] != 'No data found') {
            this.exportExcelService.base64ToCSV(res['content'], fileName);
            this.messageService.add({
              severity: 'success',
              summary: res.message,
              icon: 'pi-check-circle',
            });
            this.selectedAccountForConsmpReport = '';
            this.rangeDates3 = null;
          } else {
            this.messageService.add({ severity: 'warn', summary: res.message });
          }
        });
    }
  }

  onCheckboxChangeForConsumpReport(option: any) {
    if (option.checked) {
      this.selectedAccountForConsmpReport.push(option.value);
    } else {
      const index = this.selectedAccountForConsmpReport.indexOf(option.value);
      if (index !== -1) {
        this.selectedAccountForConsmpReport.splice(index, 1);
      }
    }
  }

  resetCheckboxesForConsumpReport() {
    this.selectedFields = [];
    this.checkboxOptionsForConsumpReport.forEach((option) => {
      option.checked = true;
    });
    this.checkboxOptionsForConsumpReport.forEach((option) => {
      this.selectedFieldsForConsumpReport.push(option.value);
    });
  }

  showExportReports() {
    this.isShowDailyReports = true;
    this.startDate = '';
    this.endDate = '';
    this.rangeDates3 = null;
    this.selectedAccountForConsmpReport = '';
  }

  showConsumptionReport() {
    this.isShowDailyReports = false;
    this.dailyReportDaterange = null;
    this.selectedAccountForDailyReport = '';
    this.selectState = '';
    this.selectedBranchForDailyReport = '';
    this.branches = [];
  }
}
